import React, { useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { ReactComponent as ViewOccur } from '../../images/events/view-occurrence.svg';
import { ReactComponent as LogOccur } from '../../images/events/log-occurrence.svg';
import IframeModal from './IframeModal';
import OccurrenceListModal from './OccurrenceListModal';

export default function LogAndViewOccurrence({ rsid, fetchOccurrencesByRsid }) {
    const [showCreate, setShowCreate] = useState(false);
    const [showList, setShowList] = useState(false);
    const [viewerSrc, setViewerSrc] = useState(null);

    const [list, setList] = useState([]);
    const [loadingList, setLoadingList] = useState(false);
    const [listError, setListError] = useState('');

    
    const CHILD_BASE = `${window.location.origin}/v1`; 
    function buildCreateUrl(rsid) {
        const u = new URL("/tasks_incident.aspx", CHILD_BASE);
        u.searchParams.set("RSID", rsid);
        u.searchParams.set("from", "react");
        return u.toString();
    }

    function buildViewUrl(incidentId) {
        const u = new URL("/tasks_incident.aspx", CHILD_BASE);
        u.searchParams.set("id", incidentId);
        u.searchParams.set("from", "react");
        return u.toString();
    }


    const createSrc = useMemo(() => buildCreateUrl(rsid), [rsid]);

    const handleLog = () => setShowCreate(true);

    const handleView = async () => {
        setShowList(true);
        setLoadingList(true);
        setListError('');
        try {
            const data = await fetchOccurrencesByRsid(rsid); // uses your shape
            setList(data);
        } catch (e) {
            setListError('Failed to load occurrences. Please try again.');
            setList([]);
        } finally {
            setLoadingList(false);
        }
    };

    const openExisting = (item) => {
        setShowList(false);
        setViewerSrc(buildViewUrl(item.incidentId)); // ?id=<incidentId>
    };

    return (
        <>
            <Button type="button"
                title="Log Occurrence"
                className="rounded-button ms-2"
                onClick={handleLog}
            >
                Log Occurrence
            </Button>

            <Button className="rounded-button ms-2" onClick={handleView} title="View Occurrence">
                View Occurrence
            </Button>

            <IframeModal
                show={showCreate}
                onHide={() => setShowCreate(false)}
                src={createSrc}
                title={`Log Occurrence`}
            />

            <OccurrenceListModal
                show={showList}
                onHide={() => setShowList(false)}
                list={list}
                loading={loadingList}
                error={listError}
                onOpen={openExisting}
            />

            <IframeModal
                show={!!viewerSrc}
                onHide={() => setViewerSrc(null)}
                src={viewerSrc || 'about:blank'}
                title="View Occurrence"
            />
        </>
    );
}
